import React, { useEffect, useMemo, useState, useRef } from "react";
import { BALANCE_RELOAD, COMMON_WEB_PATH } from "../../constant";
import { Box, Image } from "@chakra-ui/react";
import StartGameButton from "../../pages/Home/StartGameButton";
import { actionLogout, clearCashRegister } from "../../api/postApi";
import LoadingPage from "../Loading/LoadingPage";
import { useDispatch, useSelector } from "react-redux";
import ClearCashConfirm from "./ClearCashConfirm";
import EndGameDetail from "../EndGameDetail/EndGameDetail";
import { AnimatePresence } from "framer-motion";
import useMyBalance from "../../hook/useMyBalance";
import useCheckLogin from "../../hook/useCheckLogin";
import i18next from "i18next";

const ClearCashRegisterButton = () => {
  const walletCurrency = useSelector((state) => state.isWalletCurrency); //從redux store中取isWalletCurrency的值 存到walletCurrency變數中
  const [showStartGame, setShowStartGame] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  /* 同步鎖：isProcessing 要等 re-render 才生效，快速連點（或觸控雙觸發）會在那之前送出第二次請求 */
  const submittingRef = useRef(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showEndGame, setShowEndGame] = useState(false);
  const [savedBalance, setSavedBalance] = useState(null); // 儲存棄分前的餘額
  const [checked, setChecked] = useState(false); // 是否勾選
  const [transCode, setTransCode] = useState(""); // 當使用點數轉移時，儲存轉移的回傳值，要用來轉成QRcode
  const [withdrawalNumber, setWithdrawalNumber] = useState(""); //訂單號碼

  const { isMachineUser } = useCheckLogin();

  const currentBalance = useMyBalance();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({ type: "GET_BALANCE" });
  }, []);

  const handleClearCashRegister = async () => {
    if (submittingRef.current) return;
    submittingRef.current = true;
    setIsProcessing(true); //防止重複點擊

    try {
      await clearCashRegister({
        point_transfer: checked, //是否使用點數轉移
      }).then((data) => {
        const { balance, withdrawal_number, trans_code = "" } = data || {};
        setSavedBalance(balance || 0);
        setWithdrawalNumber(withdrawal_number || ""); //存 傳來的訂單號碼

        dispatch({
          type: "MANUAL_UPDATE_BALANCE",
          payload: {
            currency: walletCurrency,
            amount: 0,
          },
        }); // 手動更新餘額到 Redux
        if (trans_code) {
          setTransCode(trans_code);
        } else {
        }
      /* 原本這幾個 setState 包在 setTimeout(..., 0) 裡。
         React 18 的 await 之後本來就會自動批次,不需要繞這一圈;
         而且延到下一個 tick 會讓「遮罩已收、結算畫面還沒開」中間空一幀,
         機台上看得出來閃一下。直接同步設,同一次 render 換過去。 */
      setShowConfirm(false);
      setShowEndGame(true);
      // 關閉確認視窗
      });

      // 等待動畫完成

      // 2.觸發登出但不跳轉
      // dispatch({
      //   type: "USER_LOGOUT",
      //   shouldRedirect: false, // 指定不要跳轉
      // });

      // 3.顯示開始遊戲按鈕
      //setShowStartGame(true);
    } catch (error) {
      /* 這裡刻意「不」關彈窗。
         攔截器已經 dispatch API_ERROR → 會跳錯誤 toast,
         彈窗留著讓使用者看完訊息後自己決定重試或取消。
         遮罩由 finally 的 setIsProcessing(false) 收掉,不會卡住。 */
      console.error("棄分失敗:", error);
    } finally {
      submittingRef.current = false;
      setIsProcessing(false);
    }
  };

  // 點擊棄分按鈕時，顯示確認彈窗
  const handleClick = () => {
    if (currentBalance == 0) return;
    setShowConfirm(true);
  };

  // 取消棄分
  const handleCancel = () => {
    setShowConfirm(false);
  };

  // 處理 EndGameDetail 關閉
  const handleEndGameClose = () => {
    setShowEndGame(false);
    setTransCode(""); // 清空transCode
    setChecked(false); // 重設point_transfer狀態
  };

  return (
    <AnimatePresence>
      {/* 確認彈窗 */}
      {showConfirm && (
        <ClearCashConfirm
          onConfirm={handleClearCashRegister}
          onCancel={handleCancel}
          isProcessing={isProcessing}
          setChecked={setChecked}
          checked={checked}
        />
      )}

      {showEndGame && (
        <EndGameDetail
          onClose={handleEndGameClose}
          previousBalance={savedBalance}
          transCode={transCode}
          withdrawalNumber={withdrawalNumber}
        />
      )}

      {/* 棄分按鈕 */}
      <Box
        onClick={handleClick}
        position="relative"
        cursor={isProcessing || currentBalance == 0 ? "not-allowed" : "pointer"}
        display="flex"
        alignItems={"center"}
        justifyContent={"center"}
      >
        <Image
          filter={currentBalance == 0 ? "grayscale(100%)" : ""}
          opacity={currentBalance == 0 ? "0.5" : "1"}
          src={`${COMMON_WEB_PATH}/theOne/header/give_up_point_icon${
            i18next.language == "tw" ? "" : `_${i18next.language}`
          }.png`}
          height={{
            base: "60px",
            //xl: "90px",
            xl: isMachineUser ? "75px" : "75px",
          }}
          //minW="90px"
          minW={isMachineUser ? "75px" : "75px"}
        />
      </Box>

      {/* {showStartGame && <StartGameButton />} */}
    </AnimatePresence>
  );
};

export default ClearCashRegisterButton;
